"use client"
/* */
import tokens from '../../../../design-tokens/dist/variables.json.mjs';

const categoricalColors = Object.keys(
  tokens.color.categorical
);

export { categoricalColors };
//# sourceMappingURL=CategoricalColors.mjs.map
